import { randomize } from '@/data/constants';

export default {
  computed: {
    translations() {
      return this.$store.state.translations.data;
    }
  },
  methods: {
    getRandomizeRecipe({ model }) {
      this.resetUpgradeOptions().then(() => {
        const isEmbroideryApplied = this.$store
          .getters['personalization/isPersonalizationInComponentRecipe']();
        const { componentName, personalization } = (isEmbroideryApplied &&
          this.$store.getters['personalization/getPersonalizationData']) || {};

        this.$store.dispatch('randomize/GET_RANDOMIZE_RECIPE', { isEmbroideryApplied, model })
          .then(recipe => {
            this.$store.commit('recipe/SET_RECIPE_V2', recipe);

            if (personalization) {
              this.$store.commit('recipe/SAVE_PERSONALIZATION', { componentName, personalization });
              recipe.components[componentName].personalization = personalization;
            }

            this.setSwatchesSelectedFromRecipe(this.recipe_v2);
            this.$store.commit('ugc/tempData/SET_RECIPE', recipe);
            this.applyRandomizeRecipe({ recipe });
          }).catch((err) => {
            console.log("Error getting randomize recipe", err);
          });
      });
    },
    applyRandomizeRecipe({ recipe }) {
      new Promise((resolve, reject) => {
        this.$eventBus.$emit('apply-recipe', {recipe, resolve, reject, applyingRecipe: true});
      }).then(()=>{
        this.applyExclusivitybyDefaultComponent().then(()=> {
          this.$store.dispatch("buyPanel/GET_PRICE", { recipe });
          this.$store.commit("utils/SET_IS_RANDOMIZE_APPLIED", false);
          this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'swatches', status: false });
          this.$toast(this.translations?.randomize?.sucess, {
            timeout: 1500,
            closeButton: false,
            icon: "icon-randomize"
          });
        });
      });
    },
    onRandomizeClick() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({
          type: this.$customizerDataLayer.types.customizerSubMenu,
          eventLabel: randomize
        });
      }
      this.$store.commit('utils/SET_TRAY_DISABLED_STATUS', { element: 'swatches', status: true });
      this.$store.commit("utils/SET_IS_RANDOMIZE_APPLIED", true);
      this.$store.commit(
        'undo/UPDATE_PREVIOUS_RECIPE',
        { recipe: this.$store.state.recipe.recipe_v2, feature: randomize },
      );
      this.getRandomizeRecipe({ model: this.pdm.sku });
    }
  }
};